export default {
  methods: {
    scrollTo(refName,valSec) {
    	var c = valSec || 0; 
	    var element = this.$refs[refName];
	    var top = element.offsetTop - c;
	    window.scrollTo(0, top);
	  }
  }
}